import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Toggle from 'react-toggle';
import Select from 'react-select';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffsCerficationsConsolidated extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      certifications_ids: '',
      aircraft_model_id: '',
      applicability_id: '',
      staff_ids: '',
      active: 1,
      hide_columns: 0,
      certifications_list: [],
      certifications_index: [],
      staff_certifications: [],
      aircraft_models_list: [],
      staff_list: [],
      view_table: 0,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.searchStaffCertifications = this.searchStaffCertifications.bind(this);
    this.loadData = this.loadData.bind(this);
    this.exportCsv = this.exportCsv.bind(this);

    this.locale = getLocale();
  }
  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aplicabilidade/colaboradores/listagens/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            staff_list: responseJson.data.staffs,
            aircraft_models_list: responseJson.data.aircraft_models,
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  exportCsv(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      certifications_ids: this.state.certifications_ids,
      aircraft_model_id: this.state.aircraft_model_id,
      staff_ids: this.state.staff_ids,
      applicability_id: this.state.applicability_id,
      active: this.state.active,
      hide_columns: this.state.hide_columns,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/treinamentos/consolidados', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  searchStaffCertifications(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      certifications_ids: this.state.certifications_ids,
      aircraft_model_id: this.state.aircraft_model_id,
      applicability_id: this.state.applicability_id,
      staff_ids: this.state.staff_ids,
      active: this.state.active,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/tripulantes/treinamentos/consolidados', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({colunas: responseJson.data.colunas});
          self.setState({linha: responseJson.data.linha});
          self.setState({view_table: 1});
        }
        self.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/certificados/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({certifications_list: responseJson.data});
        }
      }).then(() => {
      fetch(config.get('api') + '/funcionarios/lista', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({staff_list: responseJson.data});
        }
      }).then(() => {
      fetch(config.get('api') + '/aeronave/modelo/lista/modelos', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({aircraft_models_list: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */ }); /* lista staff */}); /* lista aircraft_models */
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchStaffCertifications}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={[
                  {value: '1', label: this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.opcoesAplicabilidade.Tripulantes135},
                  {value: '4', label: this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.opcoesAplicabilidade.Tripulantes121},
                  {value: '3', label: this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.opcoesAplicabilidade.Coordenadores},
                  {value: '5', label: this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.opcoesAplicabilidade.MestresDeCarga},
                ]}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.Colaboradores}:</label>
              <Select
                className=""
                name="staff_ids"
                value={this.state.staff_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.placeholder.SelecionarColaboradores}
                onChange={this.handleSelectChangeMulti.bind(this, 'staff_ids')}
                options={this.state.staff_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.Certificados}:</label>
              <Select
                className=""
                name="certifications_ids"
                value={this.state.certifications_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.placeholder.SelecionarCertificados}
                onChange={this.handleSelectChangeMulti.bind(this, 'certifications_ids')}
                options={this.state.certifications_list}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.Designacoes}:</label>
              <Select
                className=""
                name="aircraft_model_id"
                value={this.state.aircraft_model_id}
                searchable={true}
                placeholder={this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.placeholder.SelecionarModeloDeAeronave}
                onChange={this.handleSelectChange.bind(this, 'aircraft_model_id')}
                options={this.state.aircraft_models_list}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.ApenasAtivos}?</label>
              <br/>
              <Toggle
                checked={this.state.active}
                aria-label='No label tag'
                name="active"
                onChange={this.handleToggleChange.bind(this, 'active')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.formulario.OcultarCamposPadroesDeTripulantes}?</label>
              <br/>
              <Toggle
                checked={this.state.hide_columns}
                aria-label='No label tag'
                name="hide_columns"
                onChange={this.handleToggleChange.bind(this, 'hide_columns')} />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.general.buscar}</button>
        </div>
      </form>
      <hr/>
      {(self.state.view_table == 1) ?
        <div className="listing table-responsive">
          <hr/>
          <button className="btn btn-success btn-xs button-inline" value={this.state.view_table} onClick={this.exportCsv}>
            <i className="fa fa-fw fa-table"></i> {this.locale.Tripulantes.ControleDeTreinamentosConsolidados.botaoExportarEmCSV}
          </button>
          <table className="table table-bordered table-striped table-hover">
              <thead>
                  <tr>
                      <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.Matricula}</th>
                      <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.NomeDeGuerra}</th>
                      {self.state.hide_columns == 0 ?
                        <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.Designacao}</th>
                        : ""
                      }
                      <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.Cargo}</th>
                      {self.state.hide_columns == 0 ?
                        <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.Licenca}</th>
                        : ""
                      }
                      {self.state.hide_columns == 0 ?
                        <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.CHT}</th>
                        : ""
                      }
                      {self.state.hide_columns == 0 ?
                        <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.IFR}</th>
                        : ""
                      }
                      {self.state.hide_columns == 0 ?
                        <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.CMA}</th>
                        : ""
                      }
                      {self.state.hide_columns == 0 ?
                        <th>{this.locale.Tripulantes.ControleDeTreinamentosConsolidados.tabela.Noturno}</th>
                        : ""
                      }
                      {Object.keys(self.state.colunas).map(function(c) {
                        return (
                          <th>{self.state.colunas[c]}</th>
                        );
                      })}
                  </tr>
              </thead>
              <tbody>
                  {Object.keys(self.state.linha).map(function(l) {
                    return (
                      <tr>
                          <td>{self.state.linha[l]['matricula']}</td>
                          <td>{self.state.linha[l]['nickname']}</td>
                          {self.state.hide_columns == 0 ?
                            <td>{self.state.linha[l]['designation']}</td>
                            : ""
                          }
                          <td>{self.state.linha[l]['role']}</td>
                          {self.state.hide_columns == 0 ?
                            <td>{self.state.linha[l]['license']}</td>
                            : ""
                          }
                          {self.state.hide_columns == 0 ?
                            <td dangerouslySetInnerHTML={{__html: self.state.linha[l]['cht']}}></td>
                            : ""
                          }
                          {self.state.hide_columns == 0 ?
                            <td dangerouslySetInnerHTML={{__html: self.state.linha[l]['ifr']}}></td>
                            : ""
                          }
                          {self.state.hide_columns == 0 ?
                            <td dangerouslySetInnerHTML={{__html: self.state.linha[l]['ccf']}}></td>
                            : ""
                          }
                          {self.state.hide_columns == 0 ?
                            <td dangerouslySetInnerHTML={{__html: self.state.linha[l]['noturno']}}></td>
                            : ""
                          }
                          {Object.keys(self.state.colunas).map(function(c) {
                            return (
                              <td dangerouslySetInnerHTML={{__html: self.state.linha[l][self.state.colunas[c]]}}></td>
                            );
                          })}
                      </tr>
                    );
                  })}
              </tbody>
          </table>
        </div>
        : ''
      }
    </div>
  </div>
</div>
    );
  }
}

export default StaffsCerficationsConsolidated;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsCerficationsConsolidated.js